<template>
  <v-row>
    <v-col sm="1" lg="2" class="hidden-xs-only">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" sm="10" lg="8">
      <DetailCard title="Detalles lider" :loading="cardLoading">
        <v-row justify="center">
          <v-col
            v-for="(item, index) in lider"
            :key="index"
            cols="12"
            sm="10"
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != ''">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">No registrado</p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from "../../../components/admin/DetailCard.vue";

export default {
  data: () => ({
    cardLoading: true,
  }),

  components: {
    DetailCard,
  },

  mounted() {
    this.$store.dispatch("obtenerCampesenaLiderId", this.$route.params.idLider);
    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },

  computed: {
    lider() {
      const detalles = this.$store.getters.obtenerLiderCampesena;
      const lider = [
       
        {
          label: "Identificación",
          value: detalles.identificacion,
        },
        {
          label: "Nombres",
          value: detalles.nombres,
        },
        {
          label: "Apellidos",
          value: detalles.apellidos,
        },
        {
          label: "Correo",
          value: detalles.correo,
        },
        {
          label: "Teléfono Móvil",
          value: detalles.telefono_movil,
        },
        {
          label: "Dirección",
          value: detalles.direccion,
        },
        {
          label: "Fecha de Nacimiento",
          value: detalles.fecha_nacimiento,
        },
        {
          label: "Género",
          value: detalles.genero,
        },
        {
          label: "Talla Camiseta",
          value: detalles.talla_camiseta,
        },
        {
          label: "Competencia",
          value: detalles.competencia,
        },
        {
          label: "Categoría",
          value: detalles.categoria,
        },
        {
          label: "Saber",
          value: detalles.saber,
        },
        
        {
          label: "Tipo de Líder",
          value: detalles.tipo_lider,
        },
        {
          label: "Centro de Formación",
          value: detalles.centro_formacion,
        },
      ];

      return lider;
    },
  },

  methods: {
    regresar() {
      this.$router.back();
    },
  },
};
</script>
